
import { useRef } from 'react'
import Button from '../forms/Button'
import Header from '../typography/Header'
import styles from './styles/LeadGenForm.css'

export const LeadGenForm = () => {
  const formRef = useRef(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    window.open(`${CONFIG.assetsBaseURL}/documents/scite-data-sheet.pdf?v=2`, '_blank')
    window.location.href = `https://scite.ai${CONFIG.bookDemoURL}`
  }
  return (
    <form className={styles.leadGenForm} onSubmit={handleSubmit} ref={formRef}>
      <div className={styles.assetContainer}>
        <img className={styles.img} alt='learn-more-asset' src={`${CONFIG.assetsBaseURL}/images/illustrations/one-pager.png`} />
      </div>
      <div className={styles.formContainer}>
        <Header level={6}> Learn more about how scite can help your organization and what our users are saying about us </Header>
        <Button className={styles.submitBtn} color='blue'>
          See data sheet
        </Button>
      </div>
    </form>
  )
}
